import { Component, OnInit } from '@angular/core';
import { GenericDocContainerModel, MembershipPointsTxnService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { SubSink } from 'subsink2';
import { Subject, } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PointsViewColumn1ViewModelActions } from '../../../generic-doc-view-model-controller/generic-doc-points-view-model-controller/actions';
import { PointsViewColumn1ViewSelectors } from '../../../generic-doc-view-model-controller/generic-doc-points-view-model-controller/selectors';
import { PointsViewColumnViewModelStates } from '../../../generic-doc-view-model-controller/generic-doc-points-view-model-controller/states';
import { GridOptions } from 'ag-grid-enterprise';
import { SessionActions } from "../../../modules/session/session-controller/actions";
import { SessionSelectors } from '../../../modules/session/session-controller/selectors';
import { SessionStates } from '../../../modules/session/session-controller/states';
import { Store } from '@ngrx/store';
import { SharedUtilitiesHelperFunctions } from '../../helper-functions';

@Component({
  selector: 'app-points-txn',
  templateUrl: './points-txn.component.html',
  styleUrls: ['./points-txn.component.css']
})
export class PointsTxnComponent implements OnInit {

  protected subs = new SubSink();
  private columnMoveSubject: Subject<void> = new Subject<void>();
  private debounceTimeMs = 500;
 
  gridApi;
  gridColumnApi;
  rowData: [];
  gridOptions:GridOptions = {
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', key: 'totalAndFilter', align: 'left' },
      ]
    },
    defaultColDef: {
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 100,
      flex: 1,
      sortable: true,
      resizable: true,
     // suppressCsvExport: true,
      floatingFilter: true
    },
    pagination: true
  }

  columnsDefs = [
    { headerName: 'Member ID', field: 'bl_crm_membership_points_txn_line.card_no', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Txn Type', field: 'bl_crm_membership_points_txn_line.txn_type', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Currency', field: 'bl_crm_membership_points_txn_line.point_currency', cellStyle: () => ({ 'text-align': 'left' }) },
    {
      headerName: 'Points', field: 'bl_crm_membership_points_txn_line.points_value', type: 'numericColumn',
      valueFormatter: params => params.value? SharedUtilitiesHelperFunctions.currencyFormatter(params.value):'',
    },
    { 
      headerName: 'Txn Date', field: 'bl_crm_membership_points_txn_line.date_txn', cellStyle: () => ({ 'text-align': 'left' }),
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD') : '',
    },
    { 
      headerName: 'Valid From', field: 'bl_crm_membership_points_txn_line.date_valid_from', cellStyle: () => ({ 'text-align': 'left' }), 
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD') : '',
    },
    { 
      headerName: 'Valid To', field: 'bl_crm_membership_points_txn_line.date_valid_to', cellStyle: () => ({ 'text-align': 'left' }), 
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD') : '',
    },
  ];

  constructor(
    public readonly viewModelStore: Store<PointsViewColumnViewModelStates>,
    protected readonly sessionStore: Store<SessionStates>,
    protected membershipPointsTxnService: MembershipPointsTxnService
  ) { }

  ngOnInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
  }

  createData(genericDoc: GenericDocContainerModel) {
    console.log("on create data....");

    const guids = [...new Set(
      genericDoc.bl_fi_generic_doc_line
        .map(line => line.guid))];

    const pagination = new Pagination();
    pagination.conditionalCriteria.push({
      columnName: 'guids_generic_doc_line',
      operator: '=',
      value: guids.toString()
    });

    pagination.conditionalCriteria.push({
      columnName: 'calcTotalRecords',
      operator: '=',
      value: 'false'
    });

    this.subs.sink = this.membershipPointsTxnService.getByCriteriaLines(pagination, AppConfig.apiVisa).pipe(
    ).subscribe(resp => {
      this.gridApi.setRowData(resp.data);
    }, err => {
      console.log(err);
    }); 

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  saveColumnStateToLocal(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.viewModelStore.dispatch(PointsViewColumn1ViewModelActions.setGenericDocPointsListing_State({genericDocPointsListingState:serializedColumnState}))
  }
  ngAfterViewInit() {
    // Listen for column movement and debounce the action dispatch
    this.subs.add(
      this.columnMoveSubject
        .pipe(debounceTime(this.debounceTimeMs))
        .subscribe(() => {
          this.saveColumnStateToLocal(this.gridOptions.columnApi);
          this.saveColumnStateToBackend(this.gridOptions.columnApi);
        })
    );
    
    this.subs.sink = this.viewModelStore
      .select(PointsViewColumn1ViewSelectors.selectGenericDocPointsListing_State)
      .subscribe((data) => {
        if (!data) {
          this.subs.sink = this.sessionStore
            .select(SessionSelectors.selectPersonalSettings)
            .subscribe((data) => {
              if (data.genericDocPointsListingState) {
                console.log("data",data.genericDocPointsListingState);
                this.viewModelStore.dispatch(
                  PointsViewColumn1ViewModelActions.setGenericDocPointsListing_State({
                    genericDocPointsListingState: data.genericDocPointsListingState,
                  })
                );
              }
            });
        }
      });
    
    setTimeout(()=>{
      let serializedColumnState;
      this.subs.sink = this.viewModelStore.select(PointsViewColumn1ViewSelectors.selectGenericDocPointsListing_State).subscribe(data=>{
        if(data){
          serializedColumnState=data;
        }
      })
      if (serializedColumnState) {
        const newColumnState = JSON.parse(serializedColumnState);
        const currentColumnState = this.gridOptions.columnApi.getColumnState();
        const currentColumnIds = new Set(currentColumnState.map(column => column.colId));
      
        const hiddenColumns = {};
          currentColumnState.forEach(column => {
            if (column.hide) {
              hiddenColumns[column.colId] = true;
            }
          });
        const filteredNewColumnState = newColumnState.filter(column => currentColumnIds.has(column.colId));
        const combinedColumnState = filteredNewColumnState.map(column => {
            if (hiddenColumns[column.colId] !== undefined) {
              column.hide = hiddenColumns[column.colId];
            }
            return column;
          });
          this.gridOptions.columnApi.applyColumnState({
            state: combinedColumnState,
            applyOrder: true, // Set this to true to forcefully apply the state
          });
          console.log('Column State Applied:', combinedColumnState);
      }
    
    },2000);
    
   
    
  }
  
  // Define a function to save column state to the backend
  saveColumnStateToBackend(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.sessionStore.dispatch(SessionActions.saveColumnStateInit({ settings: {genericDocPointsListingState:serializedColumnState} }));
   }
  ngAfterViewChecked() {
    // Listen for column visibility changes
    this.gridOptions.api.addEventListener("columnVisible", (event) => {
      this.columnMoveSubject.next();
    });
    // Listen for column movement
    this.gridOptions.api.addEventListener("columnMoved", (event) => {
      this.columnMoveSubject.next();
    });
  }

}
